function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A24BDB"
    },
    points: "1768,1381.15 1707.41,1407.01 1681.55,1467.6 1655.8,1407.01 1595.21,1381.15  1655.8,1355.4 1681.55,1294.81 1707.41,1355.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D20763"
    },
    d: "M450.19,320.1c28.11,0,51.02,22.91,51.02,51.02c0,27.99-22.91,50.9-51.02,50.9 c-27.99,0-50.9-22.91-50.9-50.9C399.29,343.01,422.2,320.1,450.19,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD93B"
    },
    d: "M991.23,392.73c318.52,0,576.7,357.62,576.7,676.03c0,318.53-258.18,576.71-576.7,576.71 c-318.41,0-576.59-258.18-576.59-576.71C414.64,750.35,672.82,392.73,991.23,392.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M991.23,1669.504c-81.067,0-159.724-15.886-233.786-47.217 c-71.524-30.258-135.755-73.568-190.909-128.729c-55.155-55.164-98.461-119.406-128.715-190.945 c-31.329-74.08-47.214-152.76-47.214-233.853c0-80.262,16.193-166.141,46.829-248.351 c30.064-80.677,74.118-158.193,127.398-224.168c56.051-69.405,120.064-124.463,190.262-163.644 c75.967-42.402,155.415-63.901,236.135-63.901c80.746,0,160.213,21.499,236.197,63.9 c70.212,39.18,134.236,94.238,190.295,163.644c53.287,65.973,97.346,143.489,127.412,224.168 c30.637,82.209,46.83,168.087,46.83,248.352c0,81.095-15.886,159.774-47.216,233.853 c-30.257,71.541-73.566,135.784-128.729,190.946c-55.161,55.162-119.403,98.473-190.942,128.729 C1151,1653.618,1072.322,1669.504,991.23,1669.504z M991.23,416.764c-141.654,0-279.804,74.465-389,209.678 C499.816,753.254,438.674,918.607,438.674,1068.76c0,304.746,247.875,552.676,552.556,552.676 c304.741,0,552.666-247.93,552.666-552.676c0-150.159-61.146-315.511-163.568-442.317 C1271.116,491.229,1132.932,416.764,991.23,416.764z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1343.322,750.057c-7.76,0-15.374-3.75-20.008-10.686 c-38.516-57.655-84.911-106.72-134.17-141.891c-10.803-7.713-13.308-22.723-5.595-33.526 c7.713-10.802,22.724-13.309,33.526-5.594c54.71,39.062,103.901,90.98,146.209,154.309c7.373,11.038,4.403,25.962-6.635,33.336 C1352.55,748.745,1347.91,750.057,1343.322,750.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,572.784c-13.274,0-24.034-10.76-24.034-24.034v-24.92 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.92C376.314,562.024,365.554,572.784,352.28,572.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M424.44,620.144h-24.8c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.8 c13.274,0,24.034,10.76,24.034,24.034S437.714,620.144,424.44,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,692.304c-13.274,0-24.034-10.76-24.034-24.034v-24.8 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.8C376.314,681.544,365.554,692.304,352.28,692.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M304.92,620.144H280c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.92 c13.274,0,24.034,10.76,24.034,24.034S318.194,620.144,304.92,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M450.19,446.054c-41.319,0-74.934-33.615-74.934-74.934c0-41.385,33.615-75.054,74.934-75.054 c41.385,0,75.054,33.669,75.054,75.054C525.244,412.439,491.575,446.054,450.19,446.054z M450.19,344.134 c-14.814,0-26.866,12.106-26.866,26.986c0,14.814,12.052,26.866,26.866,26.866c14.88,0,26.986-12.052,26.986-26.866 C477.176,356.24,465.07,344.134,450.19,344.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1681.55,1491.634c-0.006,0-0.012,0-0.019,0c-9.634-0.007-18.333-5.767-22.101-14.634 l-21.966-51.684l-51.689-22.061c-8.86-3.782-14.607-12.489-14.6-22.124c0.007-9.634,5.767-18.333,14.634-22.101l51.664-21.957 l21.956-51.665c3.769-8.867,12.468-14.626,22.102-14.634c0.006,0,0.013,0,0.019,0c9.628,0,18.325,5.744,22.105,14.6 l22.062,51.69l51.684,21.966c8.867,3.768,14.627,12.467,14.634,22.101c0.008,9.635-5.739,18.342-14.6,22.124l-51.71,22.069 l-22.069,51.709C1699.876,1485.889,1691.177,1491.634,1681.55,1491.634z M1656.548,1381.197l8.687,3.707 c5.711,2.438,10.257,6.99,12.685,12.705l3.678,8.653l3.708-8.688c2.433-5.699,6.972-10.238,12.671-12.671l8.687-3.707 l-8.652-3.678c-5.715-2.428-10.268-6.974-12.705-12.685l-3.708-8.688l-3.677,8.653c-2.434,5.727-6.993,10.285-12.72,12.719 L1656.548,1381.197z M1655.8,1355.4h0.01H1655.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1632.294c-13.273,0-24.034-10.761-24.034-24.034v-24.8 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.8C1505.984,1621.533,1495.224,1632.294,1481.95,1632.294 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1554.11,1679.774h-24.801c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.801c13.273,0,24.034,10.761,24.034,24.034S1567.384,1679.774,1554.11,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1751.935c-13.273,0-24.034-10.761-24.034-24.034V1703.1 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.801 C1505.984,1741.174,1495.224,1751.935,1481.95,1751.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1434.47,1679.774h-24.8c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.8c13.273,0,24.034,10.761,24.034,24.034S1447.743,1679.774,1434.47,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M735.77,866.394c-13.274,0-24.034-10.76-24.034-24.034c0-14.07-5.542-27.346-15.606-37.381 c-10.075-10.061-23.385-15.595-37.489-15.595c-29.206,0-52.966,23.765-52.966,52.976c0,13.274-10.76,24.034-24.034,24.034 s-24.034-10.76-24.034-24.034c0-55.716,45.324-101.044,101.034-101.044c26.931,0,52.303,10.525,71.442,29.637 c19.162,19.108,29.722,44.471,29.722,71.407C759.804,855.634,749.044,866.394,735.77,866.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1205.11,866.394c-13.273,0-24.034-10.76-24.034-24.034c0-14.069-5.541-27.347-15.603-37.387 c-10.069-10.054-23.379-15.588-37.483-15.588c-29.205,0-52.966,23.765-52.966,52.976c0,13.274-10.761,24.034-24.034,24.034 s-24.034-10.76-24.034-24.034c0-55.716,45.323-101.044,101.034-101.044c26.931,0,52.303,10.525,71.442,29.637 c19.158,19.118,29.712,44.479,29.712,71.407C1229.145,855.634,1218.384,866.394,1205.11,866.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M917.53,1363.494h-25.39c-57.425,0-113.921-15.5-163.381-44.825 c-47.935-28.421-87.993-68.938-115.842-117.17c-0.326-0.563-0.627-1.139-0.904-1.724c-1.518-3.196-2.326-6.718-2.326-10.315 c0-13.273,10.76-24.034,24.034-24.034c9.083,0,16.989,5.039,21.076,12.473c49.196,84.844,140.092,137.527,237.344,137.527h25.39 c95.979,0,186.355-51.75,235.859-135.054c6.781-11.411,21.526-15.165,32.939-8.383c11.411,6.78,15.164,21.528,8.383,32.939 c-28.106,47.298-68.056,86.973-115.528,114.738C1030.157,1348.339,974.259,1363.494,917.53,1363.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1253.18,1240.895c-39.184,0-71.007-10.039-94.586-29.839 c-46.246-38.858-42.007-99.688-41.804-102.259l47.92,3.787l0.011-0.153c-0.025,0.388-2.239,39.107,24.79,61.818 c14.678,12.325,36.101,18.577,63.669,18.577c13.273,0,24.034,10.761,24.034,24.034S1266.453,1240.895,1253.18,1240.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M551.05,1240.895c-13.274,0-24.034-10.761-24.034-24.034s10.76-24.034,24.034-24.034 c29.215,0,51.494-7.018,66.22-20.858c24.359-22.868,22.273-59.174,22.25-59.538l0.012,0.153l47.919-3.785 c0.19,2.402,4.173,59.299-37.27,98.205C626.257,1229.488,592.901,1240.895,551.05,1240.895z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.37ab24d081e145a39577a4f777535d26.svg";
export { ForwardRef as ReactComponent };